var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Root } from '@/models/Root';
import { fileToBase64 } from '@/support/String';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.root = new Root({
            avatar: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            dob: '',
            email: '',
            phone: '',
        });
        this.currentStep = 1;
        this.choice = '';
        this.isEditingDob = false;
        this.tempPassword = '';
        this.selectedFile = null;
        this.isUploading = false;
        this.uploadResults = {
            success: [],
            updated: [],
            failed: {},
        };
    }
    mounted() {
        //
    }
    close() {
        if (this.tempPassword) {
            this.tempPassword = '';
        }
        this.$emit('input', false);
        this.currentStep = 1;
    }
    avatarChanged(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        const file = event.target.files[0];
        fileToBase64(file).then((encodedFile) => {
            this.root.avatar = encodedFile;
        });
    }
    currentStepChanged(currentStep, previousStep) {
        if (currentStep === 4) {
            this.create();
        }
    }
    create() {
        this.choice === 'import' ? this.createFromExcel() : this.createUser();
    }
    createUser() {
        this.isUploading = true;
        this.root.roles = [RolesEnum.ROOT];
        this.root
            .create()
            .then((root) => {
            if (root.password) {
                this.tempPassword = root.password;
            }
            this.isUploading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.currentStep = 1;
            this.isUploading = false;
        });
    }
    createFromExcel() {
        this.isUploading = true;
        const payload = {
            excel: this.selectedFile,
            role: RolesEnum.ROOT,
        };
        this.root.create(payload).then((results) => {
            this.uploadResults = results;
            this.isUploading = false;
        });
    }
    onFileChange(event) {
        if (!event.target.files.length) {
            return;
        }
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
        this.currentStep = 4;
    }
    get getFailedCount() {
        return Object.keys(this.uploadResults.failed).length;
    }
    clear() {
        this.root = new Root();
        this.$emit('userCreated');
        this.close();
    }
};
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "currentStepChanged", null);
CreateDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            LoaderCard,
            SelectFilter,
        },
    })
], CreateDialog);
export default CreateDialog;
